// extracted by mini-css-extract-plugin
module.exports = {"TablePagination":"style_TablePagination__2ixpj","button":"style_button__2QPk5"};